/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkAddReferenceableAndCopySubscribersRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {BulkAddReferenceableAndCopySubscribersResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const bulkAddReferenceableAndCopySubscribers = (request: BulkAddReferenceableAndCopySubscribersRequest, options?: CashRequestOptions) => post<BulkAddReferenceableAndCopySubscribersRequest, BulkAddReferenceableAndCopySubscribersResponse>("/2.0/cash/bulk-add-referenceable-and-copy-subscribers", request, {...options, rejectOnError: true })